import {
    SHOW_MODAL_DIALOG,
    HIDE_MODAL_DIALOG
} from './consts';

export const initialState = {
    show: false,
    msg : null
};

export default (state = initialState, action) => {
    switch(action.type) {
        case SHOW_MODAL_DIALOG:
            return {
                ...state,
                ...action.payload
            };

        case HIDE_MODAL_DIALOG:
            return {
                ...state,
                msg : null,
                show: false
            };

        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/blocks/modal-dialog/reducer.js